const state = {
  locale: 'fr',
  showBanner: true
}

const actions = {
}

const mutations = {
  setLocale(state, locale) {
    state.locale = locale
  },
  hideBanner(state) {
    state.showBanner = false
  },
  showBanner(state) {
    state.showBanner = true
  }
}

export default  {
  namespaced: true,
  state,
  mutations,
  actions
}
